import { createSelector } from '@reduxjs/toolkit';
import { RequestTargetType } from 'gql/Request';
import { ActionStatus } from 'store/ActionState';
import { RootState } from 'store/RootReducer';
import { TargetTypesState } from './TargetTypeSlice';

const selectSelf = (state: RootState): TargetTypesState => {
  return state.targetTypes;
};

const selectTargetTypesProcessing = createSelector(selectSelf, (state: TargetTypesState): boolean => {
  return state.status === ActionStatus.PROCESSING;
});

const selectTargetTypesTouched = createSelector(selectSelf, (state: TargetTypesState): boolean => {
  return state.status !== ActionStatus.IDLE;
});

const selectAvailableTargetTypes = createSelector(selectSelf, (state: TargetTypesState): RequestTargetType[] => {
  return state.availableTargetTypes;
});

const TargetTypeSelectors = {
  selectAvailableTargetTypes,
  selectTargetTypesProcessing,
  selectTargetTypesTouched,
};

export default TargetTypeSelectors;
